export default __webpack_public_path__ + "static/media/testimonial-image6.2f0ee1bb.jpeg";